import {request} from "@/api/request.js";

const tf={
    getTF(tf,health_status,tissue,motif,start,length,snv,type){
        return request.get(
            "/tf",
            {
                tf: tf,
                health_status:health_status,
                snv,
                type,
                tissue:tissue,
                motif:motif,
                start: start,
                length: length
            }
        )
    },
    getTFSearch(tf,health_status,tissue,motif,start,length,snv,type,search){
        return request.get(
            "/tf/search",
            {
                tf: tf,
                health_status:health_status,
                snv,
                type,
                tissue:tissue,
                motif:motif,
                start: start,
                length: length,
                search
            }
        )
    },
    getTFDeduplication(tf,health_status,tissue){
        return request.get(
            "/tf_deduplication",
            {
                tfName: tf,
                health_status:health_status,
                tissue:tissue,
            }
        )
    },
    getTFChipSeq(tfName,start,length,snv,type,health_status,tissue){
        return request.get(
            "/tf_chip-seq",
            {
                tfName: tfName,
                snv,
                type,
                start: start,
                length: length,
                health_status,
                tissue
            }
        )
    },
    getTFChipSeqBySearch(tfName,start,length,snv,type,health_status,tissue,search){
        return request.get(
            "/tf_chip-seq/search",
            {
                tfName: tfName,
                snv,
                type,
                start: start,
                length: length,
                health_status,
                tissue,
                search:search,
            }
        )
    },
    getTFSnvAlterating(tfName,health_status,tissue,motif,start,length,snv,type){
        return request.get(
            "/tf_snv_alterating",
            {
                tf: tfName,
                health_status:health_status,
                tissue:tissue,
                motif:motif,
                start: start,
                length: length,
                snv,
                type
            }
        )
    },
    getTFSnvAlteratingBySearch(tfName,health_status,tissue,motif,start,length,snv,type,search){
        return request.get(
            "/tf_snv_alterating/search",
            {
                tf: tfName,
                health_status:health_status,
                tissue:tissue,
                motif:motif,
                start: start,
                length: length,
                snv,
                type,
                search
            }
        )
    },
    getPlot(tfName,health_status,tissue,motif,motif_id,snv,type){
        return request.get(
        "/tf_plot",
            {
                tf: tfName,
                health_status:health_status,
                tissue:tissue,
                motif:motif,
                motif_id:motif_id,
                snv,
                type
            }
        )
    },
    getMotif(tfName,health_status,tissue,motif,snv,type){
        return request.get(
            "/tf_motif",
            {
                tf: tfName,
                health_status:health_status,
                tissue:tissue,
                motif:motif,
                snv,
                type
            }
        )
    },
}
export default tf;
